import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var CreditCardOutline = function CreditCardOutline(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.85913 20.3901H20.1313C22.1975 20.3901 23.2639 19.3142 23.2639 17.2766V6.99341C23.2639 4.95581 22.1975 3.8894 20.1313 3.8894H3.85913C1.80249 3.8894 0.726562 4.95581 0.726562 6.99341V17.2766C0.726562 19.3237 1.80249 20.3901 3.85913 20.3901ZM2.62134 7.16479C2.62134 6.25073 3.10693 5.7937 3.98291 5.7937H20.0076C20.8835 5.7937 21.3691 6.25073 21.3691 7.16479V7.85034H2.62134V7.16479ZM3.98291 18.4858C3.10693 18.4858 2.62134 18.0288 2.62134 17.1147V10.0879H21.3691V17.1147C21.3691 18.0288 20.8835 18.4858 20.0076 18.4858H3.98291ZM5.27783 16.7625H7.6106C8.17236 16.7625 8.55322 16.3911 8.55322 15.8579V14.0869C8.55322 13.5537 8.17236 13.1824 7.6106 13.1824H5.27783C4.72559 13.1824 4.34473 13.5537 4.34473 14.0869V15.8579C4.34473 16.3911 4.72559 16.7625 5.27783 16.7625Z"
  })));
};

CreditCardOutline.displayName = 'CreditCardOutline';
export default CreditCardOutline;